import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { CiMail } from 'react-icons/ci';
import { PiPhoneCallThin } from 'react-icons/pi';
import { Tooltip } from '@mui/material';
import { FaArrowUp } from 'react-icons/fa';
import ScrollReveal from './ScrollReveal';

const Footer = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;

        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }

        // Calculate the scroll progress. This will be 0 at the top and 1 at the bottom.
        const scrollFraction = docHeight > 0 ? scrollTop / docHeight : 0;
        // We want the circle to be empty at the top and full at the bottom, so we use 1 - scrollFraction for the dash offset.
        setScrollProgress(1 - scrollFraction);
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <footer className="bg-gray-800 text-white font-nixie-one relative">
            <div className="container mx-auto py-12 px-4">
                <ScrollReveal animationClass="animate-fade-in" threshold={0.1} delay={200}>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
                        {/* Column 1: About */}
                        <div className="mb-6 md:mb-0 col-span-1 md:col-span-2 lg:col-span-1">
                            <a href='/' rel='noreferrer'>
                                <img src="../assets/VRIFY_Africa_full_logo[1].png" alt="VRIFY Africa Logo" className="w-full h-40 mb-4 object-cover" />
                            </a>
                            {/* <h3 className="text-2xl font-bold font-cormorant-upright mb-4"><a href='/'>VRIFY Africa</a></h3> */}
                            {/* <p className="text-gray-400 text-sm">
                            Experience the soul of Ghana through immersive virtual tours. Discover the culture, history, and beauty of West Africa from anywhere in the world.
                        </p> */}
                        </div>

                        {/* Column 2: Quick Links */}
                        <div className="mb-6 md:mb-0">
                            <h4 className="font-semibold text-lg mb-4 capitalize">Quick Links</h4>
                            <ul className="text-gray-400 text-sm space-y-2">
                                {/* <li><a href='/' className="hover:text-green-400 transition-colors">Home</a></li> */}
                                <li><a href='/digital-space' className="hover:text-green-400 transition-colors">Digital Space</a></li>
                                <li><a href='/about-us' className="hover:text-green-400 transition-colors">About Us</a></li>
                                <li><a href='/faqs' className="hover:text-green-400 transition-colors">Faqs</a></li>
                            </ul>
                        </div>

                        {/* Column 3: Experiences */}
                        <div className="mb-6 md:mb-0">
                            <h4 className="font-semibold text-lg mb-4 capitalize">Experiences</h4>
                            <ul className="text-gray-400 text-sm space-y-2">
                                <li><a href='/cultural-festivals' className="hover:text-green-400 transition-colors">Cultural Festivals</a></li>
                                <li><a href='/historical-tours' className="hover:text-green-400 transition-colors">Historical Tours</a></li>
                                <li><a href='/wildlife-safaris' className="hover:text-green-400 transition-colors">Wildlife Safaris</a></li>
                            </ul>
                        </div>

                        {/* Column 4: Contact us */}
                        <div className="mb-6 md:mb-0">
                            <h4 className="font-semibold text-lg mb-4 capitalize">Contact Us</h4>
                            <ul className='flex flex-col items-start gap-2 md:gap-2 whitespace-nowrap font-light text-sm'>
                                <li className='flex flex-row items-start gap-1'>
                                    <Tooltip title="E-Mail" arrow>
                                        <CiMail className='text-xl hover:text-yellow-400' />
                                    </Tooltip>
                                    <div className='flex flex-col items-start text-sm'>
                                        <div className='flex flex-row items-start'>
                                            <p className='text-sm sm:text-sm capitalize cursor-pointer'>emails: </p>
                                            <div className='flex flex-col items-start gap-1'>
                                                <p className='text-sm sm:text-sm cursor-pointer text-slate-400 hover:text-green-400 ml-1'> business@vrifyafrica.com</p>
                                                <p className='text-sm sm:text-sm cursor-pointer text-slate-400 hover:text-green-400 ml-1'> info@vrifyafrica.com</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className='flex flex-row items-start capitalize gap-1'>
                                    <Tooltip title="Phone" arrow>
                                        <PiPhoneCallThin className='text-xl hover:text-green-400' />
                                    </Tooltip>
                                    <div className='flex flex-col items-start text-sm'>
                                        <div className='flex flex-row items-start'>
                                            <p className='text-sm sm:text-sm capitalize cursor-pointer'>phone: </p>
                                            <div className='flex flex-col items-start gap-1'>
                                                <p className='text-sm sm:text-sm cursor-pointer text-slate-400 hover:text-green-400 ml-1'> +233553139500</p>
                                                <p className='text-sm sm:text-sm cursor-pointer text-slate-400 hover:text-green-400 ml-1'> +233544847395</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        {/* Column 5: Social Media */}
                        <div className="mb-6 md:mb-0">
                            <h4 className="font-semibold text-lg mb-4 capitalize">Connect With Us</h4>
                            <div className="flex space-x-4">
                                <a href="# " className="text-gray-400 hover:text-green-400 transition-colors"><FaLinkedinIn size={20} /></a>
                                <a href="# " className="text-gray-400 hover:text-green-400 transition-colors"><FaInstagram size={20} /></a>
                                {/* <a href="# " className="text-gray-400 hover:text-green-400 transition-colors"><FaFacebookF size={20} /></a> */}
                                <a href="# " className="text-gray-400 hover:text-green-400 transition-colors"><FaXTwitter size={20} /></a>
                            </div>
                        </div>
                    </div>
                </ScrollReveal>
                <ScrollReveal animationClass="animate-fade-in" threshold={0.1} delay={400}>
                    <div className="mt-10 pt-8 border-t border-gray-700 text-center font-semibold text-gray-500 text-sm">
                        <p>&copy; Copyright {new Date().getFullYear()} by <span className='hover:text-green-600 cursor-pointer'>VRIFY Africa</span> | All Rights Reserved | Developed By: VRIFY Technologies</p>
                    </div>
                </ScrollReveal>
            </div>

            {/* Scroll to Top Button */}
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    className="fixed bottom-10 right-10 h-12 w-12 rounded-full bg-gray-700/80 backdrop-blur-sm text-white flex items-center justify-center shadow-lg hover:bg-green-600 transition-all duration-300 z-50"
                    aria-label="Scroll to top"
                >
                    <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100">
                        {/* Background circle */}
                        <circle cx="50" cy="50" r="45" className="text-gray-600" strokeWidth="5" fill="none" />
                        {/* Progress circle */}
                        <circle cx="50" cy="50" r="45" className="text-green-400" strokeWidth="5" fill="none"
                            strokeDasharray={2 * Math.PI * 45}
                            strokeDashoffset={(2 * Math.PI * 45) * scrollProgress}
                            style={{ transform: 'rotate(-90deg)', transformOrigin: '50% 50%', transition: 'stroke-dashoffset 0.1s linear' }} />
                    </svg>
                    <FaArrowUp className="text-xl" />
                </button>
            )}
        </footer>
    );
};

export default Footer;